import { useState, useEffect } from "react";
import ApiClient from "../../../ApiClient";

const apiClient = ApiClient();

const useResolveTransactionReference = (sessionId) => {
    const [merchantInfo, setMerchantInfo] = useState({});
    const [isResolving, setIsResolving] = useState(true);
    const { getMerchantTransactionReference } = apiClient;

    useEffect(() => {
        if (!sessionId) {
            setIsResolving(false);
            return;
        }

        const fetch = async () => {
            try {
                setIsResolving(true);
                await getMerchantTransactionReference(sessionId, (response) => {
                    if (response.succeeded === true) {
                        setMerchantInfo(response.response);
                    }
                }, () => {});
            } catch (err) {
            } finally {
                setIsResolving(false);
            }
        };

        fetch();
    }, [sessionId, getMerchantTransactionReference]);

    return { merchantInfo, isResolving };
};

export default useResolveTransactionReference;
